import { render, staticRenderFns } from "./IbanMaskedInput.vue?vue&type=template&id=2dbf6a36&scoped=true"
import script from "./IbanMaskedInput.vue?vue&type=script&lang=js"
export * from "./IbanMaskedInput.vue?vue&type=script&lang=js"
import style0 from "./IbanMaskedInput.vue?vue&type=style&index=0&id=2dbf6a36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbf6a36",
  null
  
)

export default component.exports